import React from 'react'
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import API from '../../services/api.jsx'
import Loader from '../layout/loader.jsx'
import {toast} from 'react-toastify'
import FileHandler from '../layout/file-handler/fileHandler'

class NewsEdit extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            breadcrumb: {title: 'Back to News list', path: '/news'},
            fields: {
                label: {label: 'News name', type: 'text', required: true},
            },
            news: null
        }
    }

    createCorrectBannerUrl = (image) => {
        let urlPrefix = 'storage/news-banner/'

        let urlEnd = image.uri
        let url = urlPrefix + urlEnd

        image.uri = url
        return image
    }

    componentDidMount() {
        API.getNews(this.props.match.params.newsId).then(news => {
            var bannerImage = {}
            var coverImage = {}

            if (news.banner) {
                bannerImage = this.createCorrectBannerUrl(news.banner)
            }

            if (news.cover) {
                coverImage = this.createCorrectCoverUrl(news.cover)
            }

            this.setState({
                loading: false,
                news: news,
                tempBanner: bannerImage,
                tempCover: coverImage,
            })
        })
    }

    // Banner image
    showBannerImage = (file, fileObj, type, index) => {
        var news = this.state.news
        news.banner = this.createCorrectBannerUrl(fileObj)

        this.setState(previousState => ({
            news,
            tempBanner: news.banner
        }))
    }

    removeBannerImage = () => {
        this.setState(previousState => ({
            news: {
                ...this.state.news,
                banner: null
            },
            tempBanner: null,
        }))
    }

    createCorrectCoverUrl = (image) => {
        let urlPrefix = 'storage/news-cover/'

        let urlEnd = image.uri
        let url = urlPrefix + urlEnd

        image.uri = url
        return image
    }

    // Cover image
    showCoverImage = (file, fileObj, type, index) => {
        var news = this.state.news
        news.cover = this.createCorrectCoverUrl(fileObj)

        this.setState(previousState => ({
            news,
            tempCover: news.cover
        }))
    }

    removeCoverImage = () => {
        this.setState(previousState => ({
            news: {
                ...this.state.news,
                cover: null
            },
            tempCover: null,
        }))
    }

    // Content block
    addContentBlock = () => {
        const content = this.state.news.content

        const newBlock = {
            title: {
                en: '',
                zh: ''
            },
            description: {
                en: '',
                zh: ''
            },
        }

        const newBlocks = [...content, newBlock]

        this.setState({
            news: {
                ...this.state.news,
                content: newBlocks
            }
        })
    }

    removeContentBlock = (index) => {
        var r = window.confirm("Are you sure you want to delete this block?");
        if (r === false) return

        let content = this.state.news.content

        content.splice(index, 1)

        this.setState(prevState => ({
            ...prevState,
            content
        }))
    }

    handleChange = (e, element, subElement, lang, index = 0) => {
        var newValue = e
        let {news} = this.state

        if (element === 'content') {
            news[element][index][subElement][lang] = newValue
        } else {
            if (lang == '') {
                news[element][subElement] = newValue
            } else {
                news[element][subElement][lang] = newValue
            }
        }

        this.setState(previousState => ({
            ...previousState,
            news
        }))
    }

    updateField(e, key) {
        this.setState({
            news: {
                ...this.state.news,
                [key]: e.target.value
            }
        })
    }

    saveEntity = (updatedEntity) => {
        this.setState({loading: true})

        if (!this.state.news.name?.en || !this.state.news.name?.zh) {
            toast.error('News\' name can not be empty')
            this.setState({loading: false})
            return
        } else if (!updatedEntity.banner) {
            toast.error('News\' banner can not be empty')
            this.setState({loading: false})
            return
        } else if (!updatedEntity.cover) {
            toast.error('News\' cover can not be empty')
            this.setState({loading: false})
            return
        }

        let bannerUri = updatedEntity.banner.uri.replace('storage/news-banner/', '')
        updatedEntity.banner.uri = bannerUri

        let coverUri = updatedEntity.cover.uri.replace('storage/news-cover/', '')
        updatedEntity.cover.uri = coverUri

        API.update('news', this.props.match.params.newsId, updatedEntity).then(() => {
            toast.success('News has been updated')
            this.props.history.push('/news')
        }).catch(() => {
            toast.error('An unexpected error has occured, please try again')
            this.setState({loading: false})
        })
    }

    deleteEntity = () => {
        var r = window.confirm("Are you sure you want to delete this news?");
        if (r === false) return

        this.setState({loading: true})
        API.deleteNews(this.props.match.params.newsId).then(() => {
            toast.success('News was successfully deleted')
            this.props.history.push('/news')
        }).catch(() => {
            toast.error('An unexpected error has occured, please try again')
            this.setState({loading: false})
        })
    }

    onCancel(e, callback) {
        e.preventDefault()
        callback()
    }

    onSubmit(e, callback) {
        e.preventDefault()
        callback()
    }

    render() {
        if (this.state.loading)
            return <Loader/>
        else
            return <>
                <Head title={'Edit news'}/>
                <Content>
                    <form onSubmit={(e) => {
                        this.onSubmit(e, () => this.saveEntity(this.state.news))
                    }} className="custom-form">
                        <div className="actions clearfix">
                            <div className="buttons clearfix">
                                <button className="grey"
                                        onClick={(e) => this.onCancel(e, () => this.props.history.push('/news'))}>Cancel
                                </button>
                                <button className="blue">Save news</button>
                            </div>
                        </div>

                        <div className="block above">
                            <div className="fields container clearfix">
                                <h3>Information</h3>
                                <div className="field" key="nameEn">
                                    <label>Name in English</label>
                                    <input type="text"
                                           onChange={(e) => this.handleChange(e.target.value, 'name', 'en', '')}
                                           value={this.state.news?.name?.en || ""}/>
                                </div>
                                <div className="field" key="nameZh">
                                    <label>Name in Chinese</label>
                                    <input type="text"
                                           onChange={(e) => this.handleChange(e.target.value, 'name', 'zh', '')}
                                           value={this.state.news?.name?.zh || ""}/>
                                </div>
                                <div className="field" key="banner">
                                    <div className="file-handler-container">
                                        {this.state.tempBanner &&
                                        <FileHandler
                                            image={this.state.tempBanner.uri}
                                            name={this.state.tempBanner.name}
                                            removeImage={(type) => this.removeBannerImage(type)}
                                            type={'images'}
                                            label={'Banner'}
                                            fileType={'images'}
                                            path={'news-banner'}
                                        />
                                        }

                                        {!this.state.tempBanner &&
                                        <FileHandler
                                            showImage={this.showBannerImage}
                                            type={'images'}
                                            label={'Banner'}
                                            fileType={'images'}
                                            path={'news-banner'}
                                            dropzone
                                        />
                                        }
                                    </div>
                                </div>
                                <div className="field" key="cover">
                                    <div className="file-handler-container">
                                        {this.state.tempCover &&
                                        <FileHandler
                                            image={this.state.tempCover.uri}
                                            name={this.state.tempCover.name}
                                            removeImage={(type) => this.removeCoverImage(type)}
                                            type={'images'}
                                            label={'Cover'}
                                            fileType={'images'}
                                            path={'news-cover'}
                                        />
                                        }

                                        {!this.state.tempCover &&
                                        <FileHandler
                                            showImage={this.showCoverImage}
                                            type={'images'}
                                            label={'Cover'}
                                            fileType={'images'}
                                            path={'news-cover'}
                                            dropzone
                                        />
                                        }
                                    </div>
                                </div>

                                <div className="long-field" key="descriptionEn">
                                    <label>Description in English</label>
                                    <textarea type="text"
                                           onChange={(e) => this.handleChange(e.target.value, 'description', 'en', '')}
                                           value={this.state.news?.description?.en || ""}/>
                                </div>
                                <div className="long-field" key="descriptionZh">
                                    <label>Description in Chinese</label>
                                    <textarea type="text"
                                           onChange={(e) => this.handleChange(e.target.value, 'description', 'zh', '')}
                                           value={this.state.news?.description?.zh || ""}/>
                                </div>
                            </div>

                            <div className="fields container clearfix">
                                <h3>Content</h3>

                                {
                                    Object.keys(this.state.news.content).map(index => {
                                        return (
                                            <div className="fields container clearfix">
                                                <div>
                                                    <p style={{
                                                        textDecoration: 'underline'
                                                    }}>{parseInt(index) + 1}. Block {parseInt(index) + 1}
                                                    </p>
                                                    <label style={{
                                                        textDecorationLine: 'underline',
                                                        color: '#2196F3',
                                                        position: 'absolute',
                                                        right: '32px',
                                                        cursor: 'pointer'
                                                    }}
                                                           onClick={() => {
                                                               this.removeContentBlock(index)
                                                           }}
                                                    >Delete
                                                    </label>
                                                </div>

                                                <div className="field" key="titleEn">
                                                    <label>Title in English</label>
                                                    <input type="text"
                                                           onChange={(e) => this.handleChange(e.target.value, 'content', 'title', 'en', index, false)}
                                                           value={this.state.news?.content[index].title.en || ""}/>
                                                </div>

                                                <div className="field" key="titleZh">
                                                    <label>Title in Chinese</label>
                                                    <input type="text"
                                                        onChange={(e) => this.handleChange(e.target.value, 'content', 'title', 'zh', index, false)}
                                                        value={this.state.news?.content[index].title.zh || ""}/>
                                                </div>

                                                <div className="long-field" key="descriptionEn">
                                                    <label>Description in English</label>
                                                    <textarea type="text"
                                                        onChange={(e) => this.handleChange(e.target.value, 'content', 'description', 'en', index)}
                                                        value={this.state.news?.content[index].description.en || ""}
                                                    />
                                                </div>

                                                <div className="long-field" key="descriptionZh">
                                                    <label>Description in Chinese</label>
                                                    <textarea type="text"
                                                        onChange={(e) => this.handleChange(e.target.value, 'content', 'description', 'zh', index)}
                                                        value={this.state.news?.content[index].description.zh || ""}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })
                                }

                                <div className="buttons">
                                    <button className="blue add clearfix"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.addContentBlock()
                                            }}>
                                        Add new block
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div className="actions clearfix below-form">
                        <button onClick={() => this.deleteEntity()} className="red">Delete news</button>
                    </div>
                </Content>
            </>
    }
}

export default NewsEdit